export function HijackingCo() {
    const courses = [
        { title: "HTML and CSS in depth (From CiCdCo)", link: "https://www.coursera.org/learn/html-and-css-in-depth" },
        { title: "HTML for Beginners: Getting Started (Project Network)", link: "https://www.coursera.org/projects/html-for-beginners-getting-started" },
        { title: "Introduction to HTML (Project Network)", link: "https://www.coursera.org/projects/introduction-to-html" },
        { title: "HTML & CSS Crash Course (From Scrimba)", link: "https://www.coursera.org/learn/html--css-crash-course" },
        { title: "Build a Webpage with HTML and CSS (BOORD infinity)", link: "https://www.coursera.org/learn/build-a-webpage-with-html-and-css" }
    ];

    return (
        <>
            <h1 className="html_co_heading">
                These are the <strong style={{ textDecoration: 'underline', color: 'blue' }}>Top 5</strong> recommended Coursera courses links that you can refer to with certifications
            </h1>

            <h4 className="des_co_html">
                1. Dive Into The Main Concepts <br />
                2. Animation Explanations with real-world Examples <br />
                3. Important with Note Clarification.
            </h4>

            {/* Render courses dynamically */}
            {courses.map((course, index) => (
                <div className="container_html_co_links" key={index}>
                    <p className="vid">
                        {index + 1}. {course.title}
                        <button
                            style={{
                                marginLeft: '200px',
                                padding: '7px',
                                background: 'black',
                                color: 'white',
                                borderRadius: '8px'
                            }}
                            onClick={() => window.open(course.link, "_blank")}
                        >
                            Click Me
                        </button>
                    </p>
                </div>
            ))}
        </>
    );
}

export default HijackingCo;
